import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";
import { useInsider } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useInsider";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";
import { useMemo } from "react";

export const useSearchPageFilteredFilterSections = () => {
  const { shouldShowInsider } = useInsider();
  const {
    data: { filterSections },
  } = useFilterStore(["filterSections"]);

  return useMemo(() => {
    if (!filterSections) {
      return [];
    }
    const filterSectionsWithoutInsider = filterSections.filter(
      (s) => s.field_name !== IFilterSection.FieldName.INSIDER
    );
    return shouldShowInsider ? filterSections : filterSectionsWithoutInsider;
  }, [filterSections, shouldShowInsider]);
};
